import firebase from 'firebase/app';
import 'firebase/database';
import partners from 'envs/partners';
import { ensureFirebaseInitialized } from 'utils/firebase/firebase';
import { allowMeErrorEntryToJson } from './allowme-error-log-entry';

const CHANNEL = 'ib_web';
const APP_VERSION = '0.1.0';

let logImpl = null;

export const resolveAllowMeLogEnv = () =>
  Number(process.env.REACT_APP_API_ENUM) === 0 ? 'prod' : 'hlg';

export const resolveAllowMeLogBrand = (hostname) => {
  try {
    const host = hostname || (typeof window !== 'undefined' && window.location
      ? window.location.hostname
      : '');
    const partner = partners.find((item) => item.hostname === host);
    return (partner && partner.name) || 'ibank';
  } catch (error) {
    return 'ibank';
  }
};

export const getBrowserDeviceHeaders = () => {
  try {
    const nav = typeof navigator !== 'undefined' ? navigator : {};
    const loc = typeof window !== 'undefined' ? window.location : {};
    return {
      device_platform: 'web',
      device_brand: '--',
      device_user_agent: nav.userAgent || '--',
      device_id: '--',
      device_name: nav.platform || '--',
      device_is_emulator: 'false',
      device_carrier: '--',
      device_app_version: APP_VERSION,
      device_manufacturer: '--',
      device_model: '--',
      device_language: nav.language || '--',
      device_hostname: loc.hostname || '--',
      channel: CHANNEL,
    };
  } catch (error) {
    return {
      device_platform: 'web',
      device_user_agent: '--',
      channel: CHANNEL,
    };
  }
};

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const writeToRtdb = async (entry) => {
  const ready = await ensureFirebaseInitialized();
  if (!ready) {
    return;
  }

  const now = new Date();
  const env = resolveAllowMeLogEnv();
  const brand = resolveAllowMeLogBrand();
  const path = `allowme_errors/${env}/${formatDate(now)}`;
  const payload = allowMeErrorEntryToJson(entry, {
    brand,
    env,
    timestampMs: now.getTime(),
    serverTimestamp: firebase.database.ServerValue.TIMESTAMP,
    deviceOverride: entry.device || getBrowserDeviceHeaders(),
  });

  await firebase
    .database()
    .ref(path)
    .push()
    .set(payload);
};

export const logAllowMeError = async (entry) => {
  try {
    if (logImpl) {
      await logImpl(entry);
      return;
    }
    await writeToRtdb(entry);
  } catch (error) {
    try {
      console.warn('[AllowMe] failed to write RTDB log', {
        error: (error && error.message) || String(error),
      });
    } catch (ignored) {
      // logging must never affect app flows
    }
  }
};

export const setAllowMeErrorLogImplForTests = (impl) => {
  logImpl = impl;
};

export const resetAllowMeErrorLogForTests = () => {
  logImpl = null;
};
